<template>
    <div class="orderItem" @click="$emit('click')">
        <van-cell>
            <template #title>
                <div class="titleSlot ai-center">
                    <icon-svg size="7vw" name="hotel" />
                    <span class="ml-1 font-bold">{{ hotelName }}</span>
                </div>
            </template>
            <template #default>
                <div v-if="status == -2">
                    <span v-if="serviceStatus == -1">退订失败</span>
                    <span v-if="serviceStatus == 0">无售后</span>
                    <span v-if="serviceStatus == 1">退订</span>
                    <span v-if="serviceStatus == 2">客服审核</span>
                    <span v-if="serviceStatus == 3">卡券待退回</span>
                    <span v-if="serviceStatus == 4">退订成功</span>
                </div>
                <div v-if="status == -1">预定失败</div>
                <div v-if="status == 0">待处理</div>
                <div v-if="status == 1">处理中</div>
                <div v-if="status == 2">预定成功</div>
                <div v-if="status == 3">订单完成</div>
                <div v-if="status == 4">失效订单</div>
            </template>
        </van-cell>
        <div class="orderInfo flex ml-2">
            <div
                :style="{
                    backgroundImage: `url('${$getImageUrl(cover)}')`,
                }"
                class="bgi noImg"
            ></div>
            <div class="flex-1 ml-3 infoText">
                <div>
                    <span>{{ roomCount }}间，</span><span>{{ roomName }}</span>
                </div>
                <div>
                    <span>{{ startTime | toYearMonthDate }}</span> —— <span>{{ endTime | toYearMonthDate }}</span>
                </div>
                <div class="jc-between shrink-0">
                    <div class="addressTitle shrink-0">地址：</div>
                    <div>{{ hotelAddress }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        cover: String,
        status: [Number, String],
        serviceStatus: [Number, String],
        roomNum: [Number, String],
        hotelName: String,
        roomName: String,
        startTime: [Number, Date],
        endTime: [Number, Date],
        stars: [Number, String],
        roomCount: [Number, String],
        hotelAddress: String
    },
    data() {
        return {
            statusList: [
                { title: "全部", status: "" },
                { title: "待处理", status: "0" },
                { title: "处理中", status: "1" },
                { title: "预定成功", status: "2" },
                { title: "已完成", status: "3" },
                { title: "预定失败", status: "-1" },
                { title: "售后", status: "-2" },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.orderItem {
    background-color: #fff;
    border-radius: 2vw;
    overflow: hidden;
    margin-bottom: 1.5vw;
    /deep/.van-cell__title {
        flex: 2.5;
        .titleSlot {
            > span {
                @extend .text-one;
                max-width: 60vw;
            }
        }
    }
    /deep/.van-cell__value {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .orderInfo {
        line-height: 1.3;
        padding: 10px;
        > div:first-child {
            border-radius: 1.5vw;
            width: 15vw;
            height: 15vw;
        }
        > .infoText {
            color: #6e6e6e;
            > div {
                line-height: 1.6;
            }
            .addressTitle {
                width: 12vw;
            }
        }
    }
}
</style>
